/** Shared signup validation — web Register and mobile Crear cuenta. */

export const SIGNUP_PASSWORD_MIN = 8;
export const SIGNUP_PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/;
export const SIGNUP_EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export function validarNombreRegistro(nombre: string): true | string {
  const n = String(nombre || '').trim();
  if (!n) return 'El nombre es requerido';
  if (n.length < 2) return 'El nombre debe tener al menos 2 caracteres';
  return true;
}

export function validarApellidoRegistro(apellido: string): true | string {
  const n = String(apellido || '').trim();
  if (!n) return 'El apellido es requerido';
  if (n.length < 2) return 'El apellido debe tener al menos 2 caracteres';
  return true;
}

export function validarEmailRegistro(email: string): true | string {
  const e = String(email || '').trim();
  if (!e) return 'El correo es requerido';
  if (!SIGNUP_EMAIL_PATTERN.test(e)) return 'El formato del email no es válido';
  return true;
}

export function validarPasswordRegistro(password: string): true | string {
  if (!password) return 'La contraseña es requerida';
  if (password.length < SIGNUP_PASSWORD_MIN) {
    return 'La contraseña debe tener al menos 8 caracteres';
  }
  if (!SIGNUP_PASSWORD_PATTERN.test(password)) {
    return 'La contraseña debe contener al menos una mayúscula, una minúscula y un número';
  }
  return true;
}

export function validarConfirmPassword(password: string, confirm: string): true | string {
  if (!confirm) return 'La confirmación de contraseña es requerida';
  if (confirm !== password) return 'Las contraseñas no coinciden';
  return true;
}

/** Spanish messages for Supabase signUp / resend errors. */
export function mapSignupAuthError(raw: string): string {
  const m = String(raw || '').toLowerCase();
  if (m.includes('already registered') || m.includes('already been registered')) {
    return 'Este correo ya está registrado. Inicia sesión o usa «¿Olvidaste tu contraseña?».';
  }
  if (m.includes('password') && (m.includes('weak') || m.includes('short') || m.includes('least'))) {
    return 'La contraseña no cumple los requisitos de seguridad. Usa al menos 8 caracteres con mayúscula, minúscula y número.';
  }
  if (m.includes('invalid email') || (m.includes('email') && m.includes('invalid'))) {
    return 'El formato del correo no es válido.';
  }
  if (m.includes('rate limit') || m.includes('too many')) {
    return 'Demasiados intentos. Espera unos minutos e inténtalo de nuevo.';
  }
  return raw;
}
